
<app-nav-bar/>
<app-hero-farmacia/>
<app-info-farmacia/>
<app-footer-persona/>
